<template>
  <v-row class="d-flex align-center justify-space-between">
    <v-col sm="4">
      <div>
        <v-img :src="imgSrc" height="48" width="48" />
      </div>
    </v-col>
    <v-col sm="6">
      <TotalAccountsCardDetails :title="title" :value="value" />
    </v-col>
    <v-col sm="2">
      <Icon icon="mdi-dots-vertical" size="27" color="transparent" />
    </v-col>
  </v-row>
</template>

<script>
import Icon from "@/components/atoms/icon";
import TotalAccountsCardDetails from "@/components/atoms/Contas/total-accounts-card-details";

export default {
  components: {
    Icon,
    TotalAccountsCardDetails
  },
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.infoCard {
  width: 256px;
  height: 121px;
}
</style>